// Theme state lives on <html data-theme>; an inline script in index.html
// sets it before first paint. This module is the single writer after that.

export const THEMES = ['light', 'dark', 'paper'] as const;
export type Theme = (typeof THEMES)[number];

// Keep the browser chrome (mobile address bar) in step with each theme's --bg.
const THEME_COLORS: Record<Theme, string> = {
  light: '#f6f3ee',
  dark: '#14130f',
  paper: '#ece7dc',
};

export const THEME_EVENT = 'themechange';

export function getTheme(): Theme {
  const current = document.documentElement.getAttribute('data-theme');
  return THEMES.includes(current as Theme) ? (current as Theme) : 'light';
}

export function setTheme(theme: Theme): void {
  document.documentElement.setAttribute('data-theme', theme);
  document.querySelector('meta[name="theme-color"]')?.setAttribute('content', THEME_COLORS[theme]);
  try {
    localStorage.setItem('theme', theme);
  } catch {
    // private browsing — theme still applies for this visit
  }
  window.dispatchEvent(new CustomEvent(THEME_EVENT, { detail: theme }));
}

export function cycleTheme(): Theme {
  const next = THEMES[(THEMES.indexOf(getTheme()) + 1) % THEMES.length]!;
  setTheme(next);
  return next;
}
